import MyUtil from './MyUtil';

const ConvertCity = {
  handleNew: (data) => {
    let city = {
      city_id: data.city_id,
      city_name: data.city_name,
      city_name_en: data.city_name_en,
      city_location: data.city_location,
      city_lat: data.city_lat,
      city_long: data.city_long,
      city_code: data.city_code,
      city_popular: data.city_popular,
    };

    city = MyUtil.clean(city);
    return city;
  },
  handleCheck: (state) => {
    const {
      city_name,
      city_name_en,
      city_code,
      city_location,
      city_lat,
      city_long,
    } = state;
    const message = [];
    console.log('check ', city_name, ' - ', city_name_en, ' - ', city_code);
    if (!city_name) message.push('tên thành phố');
    if (!city_name_en) message.push('tên thành phố theo tiếng anh');
    if (!city_code) message.push('mã thành phố');
    if (!city_lat) message.push('latitude');
    if (!city_long) message.push('longitude');
    if (!city_location) message.push('khu vực (miền bắc/trung/nam)');
    return message.length > 0 ? message : false;
  },
};

export default ConvertCity;
